import styled, { css } from 'styled-components';

type Direction = 'horizontal' | 'vertical';

interface SpaceProps {
	size: number;
	direction: Direction;
}

export const Space = styled.div<SpaceProps>`
	${({ size, direction }) => css`
		${direction === 'horizontal' ? 'width:' : 'height:'} ${size}px;
	`};
`;
